import queryString from 'query-string';
import { apiSlice } from 'store/api/apiSlice';

import { StaffFeedbackListProps, StaffFeedbackQueryParams } from './staffFeedback.types';

export const staffFeedbackApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getStaffFeedbacks: build.query<StaffFeedbackListProps, { params: StaffFeedbackQueryParams }>({
      query: ({ params }) => {
        const paramsString = queryString.stringify(params, { arrayFormat: 'bracket' });
        return { url: `/admin/call-quality-feedbacks?${paramsString}` };
      },
      transformResponse: (response: StaffFeedbackListProps) => ({
        data: response.data,
        info: response.info
      })
    })
  })
});

export const { useLazyGetStaffFeedbacksQuery } = staffFeedbackApi;
